import { createBlockHandler } from './createBlockHandler'
import { deleteBlockHandler } from './deleteBlockHandler'
import { updateBlockHandler } from './updateBlockHandler'

export const websiteBlockMethods = {
  create: createBlockHandler,
  delete: deleteBlockHandler,
  update: updateBlockHandler,
}
